import React from 'react';
import { components } from 'react-select';
import PropTypes from 'prop-types';
import s from './SelectBox.styles';

const OptionWithDynamicIcon = ({ data, ...rest }) => (
  <components.Option {...rest}>
    {data.icon}
    <span>{data.label}</span>
  </components.Option>
);

OptionWithDynamicIcon.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string,
    icon: PropTypes.element,
  }),
};

export default React.memo(OptionWithDynamicIcon);
